import * as Api from '@ViewModels';
import { IRegEdIntegrationStatus } from './types';
import { useRegEdIntegrationQuery } from './useRegEdIntegrationQuery';

export const isRegEdRouted = (integration?: IRegEdIntegrationStatus | null): boolean =>
	integration?.enabled === true && integration?.configurationStatus?.needsConfiguration === false;

/**
 * Fail-closed compliance gate: true only when the integration is enabled AND fully configured, and
 * deliberately false while loading or on error — an unresolved state must never route through RegEd.
 */
export const useAccountUsesRegEd = (
	impersonationContext?: Api.IImpersonationContext,
	{ enabled = true }: { enabled?: boolean } = {}
): boolean => {
	const { data } = useRegEdIntegrationQuery({ impersonationContext, enabled });
	return isRegEdRouted(data);
};
